import axios from 'axios';
// import Global from '../../js/shared/global';

const $ = jQuery.noConflict();

export function requestSetTransient(context, payload) {
	axios.post('/wp-json/fws/v1/set_transient', {action: 'set_transient', transient: payload})
		.then((response) => {
			const productForm = $('.js-product-form');
			if (productForm.length > 0) {
				productForm.replaceWith(response.data.data);
			} else {
				$('.site-content').prepend(response.data.data);
			}

			const button = document.querySelector('.single_add_to_cart_button');
			const startDate = $('#wscsd_start_date');
			if (startDate.length > 0) {
				startDate.attr('value', response.data.date);
			}
			$('.input-text.qty.text').val(response.data.qty);
			setTimeout(function() {
				document.querySelector('.js-continue-step').classList.remove('disabled');
				document.querySelector('.js-btn-loader').classList.remove('active-loader');
				document.querySelector('.js-continue-step-text').classList.remove('active-loader');
				button.click();
			}, 250);
		})
		.catch(e => {
			throw e;
		});
}